// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"417":"6f63fae6","453":"8dfe0714"}[chunkId] + ".chunk.js";
};